import React from 'react'
import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'

const Container = styled.div`
  height: 55px;

  ${breakpoint('tablet')`
    display: none;
  `}

  &.oculto {
    display: none;
  }
`

export default () => {
  return <Container id="sticky-cta-spacer" className="oculto" />
}
